module.exports = __webpack_public_path__ + "static/img/DiwaliFestivalBg.da6d7c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DiwaliFestival/DiwaliFestivalBg.png
// module id = 5slR
// module chunks = 0